import { useGetBuildingsQuery } from '../redux/api/location';

export function useHasMultipleBuildings(): boolean {
	const { data: buildings = [] } = useGetBuildingsQuery();
	return buildings.length > 1;
}
